export const UserAddSource = {
  ONBOARD_CLI: "onboard-cli",
  BULK_UPLOAD: "bulk-upload",
  INVITE: "invite",
  CREATE: "create",
  ADMIN: "admin",
};
